// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"hx-z","giftOrPromoSelector":"ix-z","disabled":"jx-z","subTitle":"kx-z","selectShipAddressMessage":"lx-z","changePayment":"mx-z"};